export default {
    props: {
        filterableExtra: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.extra'
        }, 
        filterableMessagesAnd: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.and'
        }, 
        filterableMessagesClear: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.clear'
        }, 
        filterableMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.filter'
        }, 
        filterableMessagesInfo: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.info'
        }, 
        filterableMessagesIsFalse: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isFalse'
        }, 
        filterableMessagesIsTrue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isTrue'
        }, 
        filterableMessagesOr: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.or'
        }, 
        filterableMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.search'
        }, 
        filterableMessagesSelectValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectValue'
        }, 
        filterableMessagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.cancel'
        }, 
        filterableMessagesSelectedItemsFormat: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectedItemsFormat'
        }, 
        filterableMessagesOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.operator'
        }, 
        filterableMessagesValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.value'
        }, 
        filterableMessagesCheckAll: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.checkAll'
        }, 
        filterableMode: {
            type: String,
            default: undefined,
            kComposite: 'filterable.mode'
        }, 
        filterableOperatorsStringEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.eq'
        }, 
        filterableOperatorsStringNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.neq'
        }, 
        filterableOperatorsStringIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnull'
        }, 
        filterableOperatorsStringIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnotnull'
        }, 
        filterableOperatorsStringIsempty: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isempty'
        }, 
        filterableOperatorsStringIsnotempty: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnotempty'
        }, 
        filterableOperatorsStringStartswith: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.startswith'
        }, 
        filterableOperatorsStringContains: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.contains'
        }, 
        filterableOperatorsStringDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.doesnotcontain'
        }, 
        filterableOperatorsStringEndswith: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.endswith'
        }, 
        filterableOperatorsNumberEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.eq'
        }, 
        filterableOperatorsNumberNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.neq'
        }, 
        filterableOperatorsNumberIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.isnull'
        }, 
        filterableOperatorsNumberIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.isnotnull'
        }, 
        filterableOperatorsNumberGte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.gte'
        }, 
        filterableOperatorsNumberGt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.gt'
        }, 
        filterableOperatorsNumberLte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.lte'
        }, 
        filterableOperatorsNumberLt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.lt'
        }, 
        filterableOperatorsDateEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.eq'
        }, 
        filterableOperatorsDateNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.neq'
        }, 
        filterableOperatorsDateIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.isnull'
        }, 
        filterableOperatorsDateIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.isnotnull'
        }, 
        filterableOperatorsDateGte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.gte'
        }, 
        filterableOperatorsDateGt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.gt'
        }, 
        filterableOperatorsDateLte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.lte'
        }, 
        filterableOperatorsDateLt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.lt'
        }, 
        filterableOperatorsEnumsEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.eq'
        }, 
        filterableOperatorsEnumsNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.neq'
        }, 
        filterableOperatorsEnumsIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.isnull'
        }, 
        filterableOperatorsEnumsIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.isnotnull'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Filterable.js